module.exports = __webpack_public_path__ + "img/1.39354c79.png";